import * as React from 'react';

import {CategoryResultCard} from './CategoryResultCard';
import {pushGaEvent} from '../../../client/ga/ga.functions';
import {SearchResult, SubCat} from '../search.types';
import {URLBuilder} from '../../../server/tools/url-builder/url-builder.class';
import {User} from '../../users/user.class';

interface CategoryResultProps {
    buildURL: URLBuilder;
    debugWebcat: boolean;
    resultList: SearchResult;
    subCat: SubCat;
    user: User;
}

export const CategoryResult = ({buildURL, debugWebcat, resultList, subCat, user}: CategoryResultProps) => (
    <>
        {!(subCat.lookAheadLinks && !(user.hasCustomCatalogs() && user.hasCurrentPcode) && !resultList.brand) ? (
            <div className="tw-w-full md:tw-w-1/3 xl:tw-w-1/4 tw-mb-4 tw-pr-0 md:tw-pr-4">
                <a
                    className="tw-no-underline tw-font-bold"
                    href={buildURL.withWebcat(subCat.categoryPath)}
                    onClick={() =>
                        pushGaEvent(`ga4_category_click`, {
                            click_type: `category_click`,
                            click_action: `navigation`,
                            click_path: buildURL.withWebcat(subCat.categoryPath),
                            click_category_1: `category_tile`,
                            click_category_2: `view_additional_category`,
                            selection_name: `${resultList.title} | ${subCat.name}`,
                        })
                    }
                    style={{color: `inherit`}}
                >
                    <CategoryResultCard
                        buildURL={buildURL}
                        debugWebcat={debugWebcat}
                        resultList={resultList}
                        subCat={subCat}
                        user={user}
                    />
                </a>
            </div>
        ) : (
            <div className="tw-w-full md:tw-w-1/3 xl:tw-w-1/4 tw-mb-4 tw-pr-0 md:tw-pr-4">
                <CategoryResultCard
                    buildURL={buildURL}
                    debugWebcat={debugWebcat}
                    resultList={resultList}
                    subCat={subCat}
                    user={user}
                />
            </div>
        )}
    </>
);
